export default __webpack_public_path__ + "static/media/hurry_up.1af983b0.mp3";